import React from "react";
import Nav from "./Nav";
import Footer from "./Footer";
import FlyingPigs from "./FlyingPigs";
import CallToOrder from "./CallToOrder";
import InstallPrompt from "./InstallPrompt";
import { Outlet } from "react-router-dom";
import { Toaster } from "sonner";

export default function Layout() {
  return (
    <div className="grain-overlay relative min-h-screen bg-white text-ink">
      <FlyingPigs />
      <Nav />
      <main className="pt-[76px] md:pt-[84px]">
        <Outlet />
      </main>
      <Footer />
      <CallToOrder />
      <InstallPrompt />
      <Toaster position="bottom-right" richColors closeButton />
    </div>
  );
}
